


















































































import ToastMixin from '@/mixins/ToastMixin';
import { mixins } from 'vue-class-component';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { email, maxLength, required } from 'vuelidate/lib/validators';
import FormInput from '@/components/form/FormInput.vue';
import FormValidationMixin from '@/mixins/FormValidationMixin';

@Component({
    components: {
        FormInput,
    },
})
export default class InviteFormSheet extends mixins(
    ToastMixin,
    FormValidationMixin,
) {
    @Prop() id!: number;

    @Prop() loading!: boolean;

    submitted = false;

    formData = {
        email: '',
    };

    @Validations()
    validations = {
        formData: {
            email: {
                required,
                email,
                maxLength: maxLength(30),
            },
        },
    };

    onSubmit(): void {
        this.submitted = true;
        this.$v.formData.$touch();
        if (!!this.id && !this.$v.$invalid) {
            this.submit();
        } else {
            this.fail();
        }
    }

    @Emit('submit')
    submit(): string {
        return this.formData.email;
    }

    @Emit()
    fail(): void {
        // failed emit
    }
}
